"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var baseWallet_1 = __importDefault(require("./baseWallet"));
var fortmatic_1 = __importDefault(require("fortmatic"));
var _1 = require(".");
var Fortmatic = (function (_super) {
    __extends(Fortmatic, _super);
    function Fortmatic(apiKey) {
        var _this = _super.call(this) || this;
        var network;
        if (_1.globalNodeUrl.includes("ropsten")) {
            network = "ropsten";
        }
        else if (_1.globalNodeUrl.includes("kovan")) {
            network = "kovan";
        }
        _this.fortmatic = new fortmatic_1.default(apiKey, network);
        return _this;
    }
    Fortmatic.prototype.type = function () {
        return Fortmatic.TYPE;
    };
    Fortmatic.prototype.id = function () {
        return Fortmatic.TYPE;
    };
    Fortmatic.prototype.clearSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.fortmatic.user.logout()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    Fortmatic.prototype.loadNetworkId = function () {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isSupported()) {
                            reject(baseWallet_1.default.NotSupportedError);
                        }
                        return [4, this.sendCustomRequest("net_version")];
                    case 1:
                        res = _a.sent();
                        if (res.error) {
                            reject(res.error);
                        }
                        else {
                            resolve(Number(res.result));
                        }
                        return [2];
                }
            });
        }); });
    };
    Fortmatic.prototype.signMessage = function (message) {
        return this.signPersonalMessage(message);
    };
    Fortmatic.prototype.signPersonalMessage = function (message) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var address, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isSupported()) {
                            reject(baseWallet_1.default.NotSupportedError);
                        }
                        return [4, this.getAddresses()];
                    case 1:
                        address = _a.sent();
                        return [4, this.sendCustomRequest("personal_sign", [message, address[0]])];
                    case 2:
                        res = _a.sent();
                        if (res.error) {
                            reject(res.error);
                        }
                        else {
                            resolve(res.result);
                        }
                        return [2];
                }
            });
        }); });
    };
    Fortmatic.prototype.sendTransaction = function (txParams) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isSupported()) {
                            reject(baseWallet_1.default.NotSupportedError);
                        }
                        return [4, this.sendCustomRequest("klay_sendTransaction", [txParams])];
                    case 1:
                        res = _a.sent();
                        if (res.error) {
                            reject(res.error);
                        }
                        else {
                            resolve(res.result);
                        }
                        return [2];
                }
            });
        }); });
    };
    Fortmatic.prototype.sendCustomRequest = function (method, params) {
        var _this = this;
        if (!params) {
            params = [];
        }
        return new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.provider) {
                    return [2, resolve({ error: baseWallet_1.default.NotSupportedError })];
                }
                this.provider.sendAsync([{ id: 1, method: method, params: params }], function (error, res) {
                    if (error) {
                        resolve({ error: error });
                    }
                    else {
                        resolve(res[0]);
                    }
                });
                return [2];
            });
        }); });
    };
    Fortmatic.prototype.getAddresses = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!_this.isSupported()) {
                reject(baseWallet_1.default.NotSupportedError);
            }
            resolve([_this.provider.account]);
        });
    };
    Fortmatic.prototype.enable = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.fortmatic) {
                            return [2];
                        }
                        this.provider = this.fortmatic.getProvider();
                        return [4, this.provider.enable()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    Fortmatic.prototype.isLocked = function (address) {
        return !address;
    };
    Fortmatic.prototype.isSupported = function () {
        return !!this.provider && this.provider.isLoggedIn;
    };
    Fortmatic.prototype.name = function () {
        return "Fortmatic";
    };
    Fortmatic.LABEL = "Fortmatic";
    Fortmatic.TYPE = "FORTMATIC";
    return Fortmatic;
}(baseWallet_1.default));
exports.default = Fortmatic;
